// extracted by mini-css-extract-plugin
module.exports = {"heading":"user-attributes-list-columns_heading__1BR1s"};